import { render, staticRenderFns } from "./PlPrivacyPolicy.vue?vue&type=template&id=50f50b51&scoped=true"
import script from "./PlPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PlPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "50f50b51",
  null
  ,true
)

export default component.exports